import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { User } from 'lucide-react';

interface DinoAvatarProps {
  src?: string | null;
  name?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  fallbackClassName?: string;
}

const sizeClasses = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-8 w-8 text-sm',
  md: 'h-10 w-10 text-base',
  lg: 'h-12 w-12 text-lg',
  xl: 'h-16 w-16 text-xl',
};

const iconSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
};

export function DinoAvatar({ 
  src, 
  name, 
  size = 'md', 
  className,
  fallbackClassName 
}: DinoAvatarProps) {
  const getInitials = (name: string | null | undefined) => {
    if (!name) return '';
    return name
      .split(' ')
      .slice(0, 2)
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  const initials = getInitials(name);

  return (
    <Avatar className={cn(
      sizeClasses[size], 
      'ring-2 ring-primary/20 ring-offset-2 ring-offset-background transition-all duration-200 hover:ring-primary/40',
      className
    )}>
      <AvatarImage 
        src={src || undefined} 
        alt={name || 'User avatar'}
        className="object-cover"
      />
      <AvatarFallback 
        className={cn(
          'bg-gradient-dino text-primary-foreground font-medium shadow-soft',
          fallbackClassName
        )}
      >
        {initials || <User size={iconSizes[size]} />}
      </AvatarFallback>
    </Avatar>
  );
}
